<template>
  <div class="search-condition-wrap">
    <div class="button-wrap">
      <el-button type="primary" style="width: 110px" @click="openDialog('searchOrder')">修改條件</el-button>
    </div>
    <el-descriptions :column="2" size="large" style="width: 100%" v-if="getSearchCondition">
      <el-descriptions-item label-class-name="descriptions-label" label="門市">
        {{
          getSearchCondition.shop_id
            ? getSearchCondition.shop_id.split(' ')[1] + ' ' + getSearchCondition.shop_id.split(' ')[2]
            : '未設定'
        }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="交易日期">
        {{ getDateText(getSearchCondition.date) }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="單據">
        {{
          getSearchCondition.invoice_no || getSearchCondition.serial_number
            ? getSearchCondition.invoice_no + getSearchCondition.serial_number
            : '未設定'
        }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="電子發票狀態">
        {{
          getSearchCondition.invoice_status || getSearchCondition.invoice_status === 0
            ? mapInvoiceStatus[getSearchCondition.invoice_status].label
            : '未設定'
        }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="類型">
        <span v-if="getSearchCondition.take_away_method?.length === 0">未設定</span>
        <el-tag
          v-else
          v-for="(item, index) in getSearchCondition.take_away_method"
          :key="index"
          style="margin-right: 10px"
          type="info"
          disable-transitions
        >
          {{ mapValue[item].label }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="訂單狀態">
        <span v-if="getSearchCondition.status?.length === 0">未設定</span>
        <el-tag
          v-else
          v-for="(item, index) in getSearchCondition.status"
          :key="index"
          style="margin-right: 10px"
          type="info"
          disable-transitions
        >
          {{ mapOrderStatus[item].label }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="來源">
        <span v-if="getSearchCondition.source_platform?.length === 0">未設定</span>
        <el-tag
          v-else
          v-for="(item, index) in getSearchCondition.source_platform"
          :key="index"
          style="margin-right: 10px"
          type="info"
          disable-transitions
        >
          {{ mapValue[item].label }}
        </el-tag>
      </el-descriptions-item>
    </el-descriptions>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useGetters } from '@/utils/mapStore';
import { defineAsyncComponent } from 'vue';
import { useDialog } from '@/utils/dialog';
import { mapValue, mapOrderStatus, mapInvoiceStatus } from '@/utils/define';
import { getFormatDate } from '@/utils/datetime';
export default {
  name: 'search-condition',
  components: {
    SearchDialog: defineAsyncComponent(() => import('@/components/order/SearchDialog.vue')),
  },
  setup() {
    //取得條件
    const getSearchCondition = useGetters('order', ['getSearchCondition']);
    const getDateText = (arr) => {
      if (!arr || arr.length === 0) return '未設定';
      const d = getFormatDate();
      if (arr.every((e) => d === e)) return '當天';
      else return arr[0] + ' ~ ' + arr[1];
    };
    //彈窗
    const { dialogTemplate, openDialog } = useDialog();
    return {
      mapValue,
      mapOrderStatus,
      mapInvoiceStatus,
      getSearchCondition,
      dialogTemplate,
      openDialog,
      getDateText,
    };
  },
};
</script>
<style lang="scss" scoped>
.search-condition-wrap {
  @include white-bg;
  display: flex;
  align-items: center;
  padding: 16px 22px 0;
  position: relative;
  .button-wrap {
    position: absolute;
    top: 16px;
    right: 22px;
  }
}
</style>
